import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes, Divider } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import stockService from "./StockConsultService";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { Title } from "chart.js";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultRadioButton from '../../componentes/radio-buttons/DefaultRadioButton';
import DefaultButton from "../../componentes/button/DefaultButton";
import DefaultChip from "../../componentes/chip/DefaultChip";

export default function StockConsult() {
    const { t } = useTranslation();
    const { control, setValue, watch } = useForm();
    const userId = sessionStorage.getItem("userId");
    
    const initialState = {
        idProduct: 0,
        productCode:'',
        barCode:'',
        productName:'',
        dtBatch: null,
        quantity: '1',
        idStorage: 0,
        idStreet: 0,
        idColumn: 0,
        idLevel: 0,
        action: '0',
        status: 1,
        userId: userId,
        warningMessage: '',
    };


    const actionValue = watch("action"); // pega o valor atual do radio

    const [state, setState] = useState(initialState);
    const [alertType, setAlertType] = useState("warning");

    const {idProduct, productCode, barCode, productName, dtBatch, quantity, idStorage, idStreet, idColumn, idLevel } = state
    const {status, action } = state

    const [clearedState, setClearedState] = useState(false);
    const [message, setMessage] = useState("");
    const [warningMessage, setWarningMessage] = useState("");
    const [error, setError] = useState(warningMessage);
    const [success, setSuccess] = useState(false);
    const [rows, setRows] = useState([]);

    const columns = (t) => [
        {
            field: "productGroupName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productGroup" />;
            },
        },
        {
            field: "productName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="product" name="product" />;
            },
        },
        {
            field: "dtBatch",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="batch" name="code" />;
            },
             template: (rowData) => {
            if (!rowData.dtBatch) return "";

            // Se já vem como string dd/MM/yyyy, e não for "01/01/1", retorna direto
            if (typeof rowData.dtBatch === "string") {
                if (rowData.dtBatch === "01/01/1") {
                    return "";
                }
                if (/^\d{2}\/\d{2}\/\d{4}$/.test(rowData.dtBatch)) {
                    return rowData.dtBatch;
                }
            }

            // Se for Date ou string ISO, converte para Date
            const date = new Date(rowData.dtBatch);

            if (isNaN(date.getTime())) {
                return "";
            }

            // Verifica se a data é 01/01/0001 (ano 1)
            if (date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1) {
                return "";
            }

            // Formata para dd/MM/yyyy
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        }
         
        },
        {
            field: "productCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productCode" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.productCode}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "barCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="barCode" name="barCode" />;
            },
        },
         ...(action !== "0"
            ? [
                {
                    field: "storage",
                    textAlign: 'center',
                    headerTemplate: () => {
                        return <IconLabelSwitch isHeader={true} labelName="storage" name="address" />;
                    },
                },
                {
                    field: "street",
                    textAlign: 'center',
                    headerTemplate: () => {
                        return <IconLabelSwitch isHeader={true} labelName="street" name="map" />;
                    },
                },
                {
                    field: "column",
                    textAlign: 'center',
                    headerTemplate: () => {
                        return <IconLabelSwitch isHeader={true} labelName="column" name="column" />;
                    },
                },
                {
                    field: "level",
                    textAlign: 'center',
                    headerTemplate: () => {
                        return <IconLabelSwitch isHeader={true} labelName="level" name="level" />;
                    },
                }]
            : []),

        {
            field: "quantityUnit",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="unit" name="qtty" />;
            },
             template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantityUnit}
                        </Typography>}
                    />
                </>
            )
        }
        },
        {
            field: "quantityBox",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="box" name="qtty" />;
            },
             template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.quantityBox}
                        </Typography>}
                    />
                </>
            )
        }
        },
    ];

    useEffect(() => {
        if (state.productCode) {
            handleCodeProduct();
        }
    }, [state.productCode]);

    useEffect(() => {
        if (state.barCode) {
            handleBarCode();
        }
    }, [state.barCode]);

    useEffect(() => {
        if (state.productName) {
            handleProductName();
        }
    }, [state.productName]);


    const handleSearch = () => {
        
        let request = { ...state };

        if (!request.dtBatch) {
            delete request.dtBatch; // remove do JSON
        } else if (request.dtBatch instanceof Date) {
            request.dtBatch = request.dtBatch.toISOString();
        } else {
            request.dtBatch = new Date(request.dtBatch).toISOString();
        }
        
        stockService
            .get(request)
            .then((response) => {
                setRows(response.data)
            })
            .catch((e) => {
                setRows([]);
            });
    };

    const handleChange = (event) => {
        
        const { name, value } = event.target;
        setState(prev => ({ ...prev, [name]: value }));

        if (name === 'action')
        {
            setRows([]);   
        }

    };

    const handleCloseAlertState = () => {
        setState({ ...state, warningMessage: false });
    };

    const handleClear = () => {
        setClearedState(!clearedState);
        setState(initialState);
        setRows([]);
    };


    const handleCodeProduct = () => {
        let request = { ...state }
        stockService
            .getByCodeProduct(request)
            .then((response) => {
                
                if (response.data) {
                
                    setState(screen => ({
                        ...screen,
                        idProduct: response.data.idProduct,
                        barCode: response.data.barCode,
                        productName: response.data.productName,
                    }));
                }
            })
            .catch((e) => {
            });
    };

    const handleBarCode = () => {
        let request = { ...state }
        stockService
            .getByBarCode(request)
            .then((response) => {
                if (response.data) {
                
                    setState(screen => ({
                        ...screen,
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        productName: response.data.productName,
                    }));
                }
            })
            .catch((e) => {
            });
    };

    const handleProductName = () => {
        let request = { ...state }

        stockService
            .getByProductName(request)
            .then((response) => {
                if (response.data) {
                    setState(screen => ({
                    ...screen,
                    idProduct: response.data.idProduct,
                    productCode: response.data.productCode,
                    barCode: response.data.barCode,
                }));
                }
            })
            .catch(() => {});
    };

    const radioListAction = [
        { value: '0', text: t("quantity") },
        { value: '1', text: t("location") },
    ];

    const handleExport = () => {
        
        var dados = '';
        dados += "Grupo Produto; Produto; Lote; Código Produto; Codigo de Barras;"
        if (action === '1')
        {
            dados += "Armazém; Rua; Coluna; Nível;"    
        }
        dados += "Unidades;Caixa; \n"
        
        rows.map((item) => {

            let dt = "";
            
            if (item.dtBatch) {
                const date = new Date(item.dtBatch);
                const dia = String(date.getDate()).padStart(2, '0');
                const mes = String(date.getMonth() + 1).padStart(2, '0');
                const ano = date.getFullYear();
                dt = `${dia}/${mes}/${ano}`;
                if (dt === "01/01/1") {
                    dt = ""
                }
            }

            dados += `${item.productGroupName};${item.productName};${dt};${item.productCode};${item.barCode};`;
            if (action === '1')
            {
                dados += `${item.storage};${item.street};${item.column};${item.level};`;
            }
            dados += `${item.quantityUnit};${item.quantityBox};\n`;
        })

        const blob = new Blob([dados], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        const now = new Date();
        const dia = String(now.getDate()).padStart(2, '0');
        const mes = String(now.getMonth() + 1).padStart(2, '0'); // mês começa do 0
        const ano = now.getFullYear();

        const datasistema = `${dia}_${mes}_${ano}`;

        if (action === '0')
        {
            link.download = `Exportação_EstoqueQuantidade${datasistema}.csv`;
        }
        else
        {
            link.download = `Exportação_EstoqueLocalização${datasistema}.csv`;
        }
        link.href = url;
        link.click();
    };

    const handlewarningMessage = () => {
        let result = true;
        if (state.role === 0) {
            setState({ ...state, warningMessage: true });
            result = false;
        }

        if ((state.id === 0) && (state.password === '' && state.confirmPassword === '') || (state.password !== state.confirmPassword)) {
            setState({ ...state, warningMessage: true });
            result = false;
        }

        if (result === true)
        {
            setState({ ...state, warningMessage: false });
        }
        
        return result;
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="Consulta de Estoque"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                type={success ? "success" : warningMessage ? "warning" : "error"}
                                success={success}
                                message={message}
                                warning={warningMessage}
                                handleCloseAlert={handleCloseAlertState}
                                snackbar
                                autoClose
                            />
                            
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCode" />
                                        }
                                        name="productCode"
                                        control={control}
                                        defaultValue=""
                                        label={t("productCode")}
                                        onChange={handleChange}
                                        value={productCode}
                                        length={30}
                                        error={warningMessage && productCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="barCode" />
                                        }
                                        name="barCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={barCode}
                                        length={30}
                                        error={warningMessage && barCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="product" labelName="productName" />
                                        } 
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={100}
                                        error={warningMessage && productName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} md={2}>
                                    <CustomDatePicker
                                        id="dtBatch"
                                        name="dtBatch"
                                        selectedDate={dtBatch}
                                        handleChange={handleChange}
                                        error={warningMessage && dtBatch === ""}
                                    />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={4} md={4}>
                                    <DefaultAutocomplete
                                        name={"idStorage"}
                                        onChange={handleChange}
                                        placeholder={t("storage")}
                                        label={t("storage")}
                                        useApi
                                        endpoint='GetStorageAutoComplete'
                                        value={idStorage}
                                        defaultSize
                                        error={warningMessage && idStorage === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idStreet"}
                                        onChange={handleChange}
                                        placeholder={t("street")}
                                        label={t("street")}
                                        useApi
                                        endpoint='GetStreetAutoComplete'
                                        value={idStreet}
                                        defaultSize
                                        error={warningMessage && idStreet === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idColumn"}
                                        onChange={handleChange}
                                        placeholder={t("column")}
                                        label={t("column")}
                                        useApi
                                        endpoint='GetColumnAutoComplete'
                                        value={idColumn}
                                        defaultSize
                                        error={warningMessage && idColumn === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} md={2}>
                                    <DefaultAutocomplete
                                        name={"idLevel"}
                                        onChange={handleChange}
                                        placeholder={t("level")}
                                        label={t("level")}
                                        useApi
                                        endpoint='GetLevelAutoComplete'
                                        value={idLevel}
                                        defaultSize
                                        error={warningMessage && idLevel === 0}
                                    />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={4} md={4}>
                                    <DefaultRadioButton
                                        name="action"
                                        control={control}
                                        defaultValue="0"
                                        list={radioListAction}
                                        value={action}
                                        onChange={handleChange}
                                        center={false}
                                        error={false}
                                    />
                                </Grid>
                            </GridInputRow>
                            
                            <SearchClearSaveRow
                                onClickClear={handleClear}
                                onClickSearch={handleSearch}
                                 {...(rows.length > 0 && {
                                    onClickExport: handleExport
                                })}
                            />
       

                        </GridItemContainer>
                    </>
                }
            />
            {rows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columns(t, handleSearch)}
                            dataSource={rows}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
